import React from "react";
import {SequenceUtils} from "@/utils/SequenceUtils";
import {FtSelect} from "@/component/input/FtSelect";
import {FtDate} from "@/common/util/FtDate";

export function YMInput(props: {
    value: string;
    onChange: (value: string) => void;
}) {
    const [year, month] = props.value.split("-").map(Number);
    const years = SequenceUtils.fromTo(2002, new Date().getFullYear() + 1);
    const months = SequenceUtils.fromTo(1, 12);

    const handleYearChange = (value: number) => {
        props.onChange(FtDate.fromYmd(value, month, 1).ym());
    };

    const handleMonthChange = (value: number) => {
        props.onChange(FtDate.fromYmd(year, value, 1).ym());
    };

    return (
        <div style={{display: 'flex', alignItems: 'center', gap: 4}}>
            <FtSelect value={year.toString()}
                      width={70}
                      values={years.map(i => i.toString())}
                      onChange={value => handleYearChange(+value)}
            />

            <FtSelect value={month.toString()}
                      width={50}
                      values={months.map(i => i.toString())}
                      onChange={value => handleMonthChange(+value)}/>
        </div>
    );
}
